import { useSelector, useDispatch } from 'react-redux'
import { setUser, initialState } from 'store/auth/userSlice'
import { apiSignIn, apiSignOut, apiSignUp } from 'services/AuthService'
import { onSignInSuccess, onSignOutSuccess } from 'store/auth/sessionSlice'
import appConfig from 'configs/app.config'
import { REDIRECT_URL_KEY } from 'constants/app.constant'
import { useNavigate } from 'react-router-dom'
import useQuery from './useQuery'
import api, { endpoint } from 'services/api'
import { apiAuthPartner } from 'services/MasterDataService'

const getTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone

function useAuth() {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const query = useQuery()

    const { token, signedIn } = useSelector((state) => state.auth.session)

    const signInPartner = async(tokenData) => {
        try {
            
                
                return api.post(endpoint.api_authenticate_partner,{token: tokenData})
                .then((result) => {
                    var data = result.data;

                    const { accessToken, user } = data.data;
                    dispatch(onSignInSuccess(accessToken));
                    
                    var userMerged = user;
                    userMerged.authority = [user.authority];
                    dispatch(setUser(userMerged));

                    sessionStorage.setItem("partnerToken", accessToken);

                    debugger
                    const redirectUrl = query.get(REDIRECT_URL_KEY)
                    // navigate(
                    //     redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath
                    // )
                    return {
                        status: 'success',
                        message: '',
                    }
                })
                .catch(error => {
                console.log(error);
                if (error?.response?.data){
                    var data = error.response.data;
                    if (data?.hasErrors){
                        return {
                            status: 'failed',
                            message: data?.errors[0].message || errors.toString(),
                        }
                    }
                }
            });             
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const completeSignIn = ({ accessToken, user }) => {
        dispatch(onSignInSuccess(accessToken));

        var userMerged = user;
        userMerged.authority = [user.authority];
        dispatch(setUser(userMerged));

        const isOperator = user?.authority === 'operator' || userMerged?.authority?.includes('operator');
        const defaultPath = isOperator ? '/my-quotations' : appConfig.authenticatedEntryPath;
        const redirectUrl = query.get(REDIRECT_URL_KEY)
        navigate(
            redirectUrl ? redirectUrl : defaultPath
        )
        return {
            status: 'success',
            message: '',
        }
    }

    const signIn = async (values) => {
        try {
            return api.post(endpoint.api_authenticate, { ...values, timeZone: getTimeZone() })
            .then((result) => {
                if (result.data){
                    var data = result.data;

                    if (data.data?.requiresTwoFactor) {
                        return {
                            status: 'twoFactorRequired',
                            challengeId: data.data.challengeId,
                            resendAvailableInSeconds: data.data.resendAvailableInSeconds,
                        }
                    }

                    return completeSignIn(data.data)
                }
            })
            .catch(error => {
                console.log(error);
                if (error?.response?.data){
                    var data = error.response.data;
                    if (data?.hasErrors){
                        return {
                            status: 'failed',
                            message: data?.errors[0].message || errors.toString(),
                        }
                    }
                }
            });
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const verifyTwoFactor = async (challengeId, code) => {
        try {
            const result = await api.post(endpoint.api_authenticate_two_factor_verify, { challengeId, code })
            return completeSignIn(result.data.data)
        } catch (error) {
            const apiError = error?.response?.data?.errors?.[0]
            return {
                status: 'failed',
                errorCode: apiError?.errorCode,
                message: apiError?.message,
            }
        }
    }

    const resendTwoFactor = async (challengeId) => {
        try {
            const result = await api.post(endpoint.api_authenticate_two_factor_resend, { challengeId, timeZone: getTimeZone() })
            return {
                status: 'success',
                challengeId: result.data.data.challengeId,
                resendAvailableInSeconds: result.data.data.resendAvailableInSeconds,
            }
        } catch (error) {
            const apiError = error?.response?.data?.errors?.[0]
            return {
                status: 'failed',
                errorCode: apiError?.errorCode,
                message: apiError?.message,
                resendAvailableInSeconds: error?.response?.data?.data?.resendAvailableInSeconds,
            }
        }
    }

    const signUp = async (values) => {
        try {
            const resp = await apiSignUp(values)
            if (resp.data) {
                const { token } = resp.data
                dispatch(onSignInSuccess(token))
                if (resp.data.user) {
                    dispatch(
                        setUser(
                            resp.data.user || {
                                avatar: '',
                                userName: 'Anonymous',
                                authority: resp.data.user.authority,
                                email: '',
                            }
                        )
                    )
                }
                const isOperator = resp.data?.user?.authority === 'operator' || userMerged?.authority?.includes('operator');
                const defaultPath = isOperator ? '/my-quotations' : appConfig.authenticatedEntryPath;
                const redirectUrl = query.get(REDIRECT_URL_KEY)
                navigate(
                    redirectUrl ? redirectUrl : defaultPath
                )
                return {
                    status: 'success',
                    message: '',
                }
            }
        } catch (errors) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const handleSignOut = (expires = false) => {
        dispatch(onSignOutSuccess())
        dispatch(setUser(initialState))
        if  (expires)
            navigate(appConfig.unAuthenticatedEntryPath, {state: {expires:true}})
        else
            navigate(appConfig.unAuthenticatedEntryPath)


    }

    const signOut = async (expires = false) => {
        // await apiSignOut()
        handleSignOut(expires)
        signOutSessionStorage();
    }

    const signOutSessionStorage = async (expires = false) => {
        sessionStorage.removeItem('selectedCustomer');

    }

    return {
        authenticated: token && signedIn,
        signIn,
        verifyTwoFactor,
        resendTwoFactor,
        signUp,
        signOut,
        signInPartner,
    }
}

export default useAuth
